<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List group helpdesk
        </span>
        <a-input
          placeholder="Search..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
          v-model="filter.query"
        />
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add New
        </a-button>
      </div>

      <a-table
        :columns="columns"
        :data-source="datas"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>
        <div slot="name" slot-scope="text, record">
          <a @click="collapseVisibleEdit(record.id)"> {{ text }} </a>
        </div>

        <span slot="categories" slot-scope="text">
          <span class="comma" v-for="i in text" :key="i.id">
            {{ i.title }} <small> ({{ i.code }}) </small>
          </span>
        </span>

        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
      </a-table>

      <a-drawer
        v-if="visibleEdit"
        title="Edit"
        placement="right"
        :visible="visibleEdit"
        @close="() => (visibleEdit = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <EditItem
          :idItem="idItem"
          :close="() => (visibleEdit = false)"
          :refreshAfterUpdated="refreshAfterUpdated"
          :refreshAfterDeleted="refreshAfterDeleted"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleAdd"
        title="Add New"
        placement="right"
        :visible="visibleAdd"
        @close="() => (visibleAdd = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddItem
          :close="() => (visibleAdd = false)"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import { columns } from "./constant/column";
import AddItem from "./components/add-item";
import EditItem from "./components/edit-item";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;
const nowYear = new Date().getFullYear();
const defaultFilter = { query: "", year: +nowYear };
function range(start, end) {
  var ans = [];

  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

const listYears = range(+nowYear - 5, +nowYear + 5);
export default {
  components: {
    AddItem,
    EditItem,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      listYears,
      limit,
      visibleEdit: false,
      visibleDetail: false,
      visibleAdd: false,
      columns,
      loadingList: true,
      datas: [],
      idItem: "",
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  created() {
    this.onGetListData();
  },
  methods: {
    async getListData() {
      return await this.$apollo.query({
        query: query.getAllHelpdeskCategoryGroup,
        fetchPolicy: "no-cache",
        variables: {
          limit,
          query: this.filter.query,
          page: this.totalPage,
        },
      });
    },
    async onGetListData() {
      try {
        this.loadingList = true;
        const { data } = await this.getListData();
        this.getListDataDone(data?.getAllHelpdeskCategoryGroup || undefined);
      } catch (err) {
        this.exceptionError(err);
      }
    },
    async onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.loadingList = true;
      const { data } = await this.getListData();
      this.getListDataDone(data?.getAllHelpdeskCategoryGroup || undefined);
    },
    async onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.loadingList = true;
        const { data } = await this.getListData();
        this.paginationListDataDone(
          data?.getAllHelpdeskCategoryGroup || undefined
        );
      }
    },
    getListDataDone(datas = []) {
      this.loadingList = false;
      this.datas = datas?.length > 0 ? [...datas] : [];
      this.isPagination = datas.length >= limit;
    },
    paginationListDataDone(datas = []) {
      this.loadingList = false;
      this.datas =
        datas?.length > 0 ? [...this.datas, ...datas] : [...this.datas];
      this.isPagination = datas.length < limit;
    },
    exceptionError(err) {
      this.loadingList = false;
      this.$notification.error({
        message: "Error",
        description: "Get Item Error!",
      });
      console.error("Error", err);
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idItem = id;
        this.visibleDetail = true;
      } else {
        this.idItem = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idItem = id;
        this.visibleEdit = true;
      } else {
        this.idItem = "";
        this.visibleEdit = false;
      }
    },

    refreshAfterUpdated(item) {
      this.datas = updateForUpdated(this.datas, item);
    },
    refreshAfterDeleted(item) {
      this.datas = updateForDeleted(this.datas, item);
    },
    refreshAfterCreated(item) {
      this.datas = updateForCreated({
        list: this.datas,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },

    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
  },
};
</script>
<style scoped>
.comma::after {
  content: ", ";
  margin-left: -2px;
}
.comma:last-child:after {
  content: "";
}
</style>
